import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _applyCouponRequest = {};
var _applyCouponResponse = {
    subTotal: 'DOUBLE',
    discount: 'DOUBLE',
    total: 'DOUBLE',
};
var _bulkAddAllToProgramRequest = {};
var _bulkAddAllToProgramResponse = {};
var _bulkAddToProgramRequest = {};
var _bulkAddToProgramResponse = { results: '_bulkAddToProgramResult' };
var _bulkAddToProgramResult = { item: '_participant' };
var _bulkApproveAllParticipantRequest = {};
var _bulkApproveAllParticipantResponse = {};
var _bulkApproveParticipantRequest = {};
var _bulkApproveParticipantResponse = {
    results: '_bulkApproveParticipantResult',
};
var _bulkApproveParticipantResult = { item: '_participant' };
var _bulkCreateResolvedStepMigrationRequest = {
    resolvedSteps: '_resolvedStep',
};
var _bulkCreateResolvedStepMigrationResponse = {
    results: '_bulkResolvedStepResult',
};
var _bulkInviteAllToProgramRequest = {};
var _bulkInviteAllToProgramResponse = {};
var _bulkInviteToProgramRequest = {};
var _bulkInviteToProgramResponse = { results: '_bulkInviteToProgramResult' };
var _bulkInviteToProgramResult = { item: '_participant' };
var _bulkResolvedStepResult = { item: '_resolvedStep' };
var _certificate = { issuedDate: 'google.protobuf.Timestamp' };
var _deleteParticipantRequest = {};
var _deleteParticipantResponse = {};
var _description = { image: '_image', video: '_videoV2' };
var _exportParticipantsStatsRequest = {};
var _exportParticipantsStatsResponse = {};
var _getParticipantRequest = {};
var _getParticipantResponse = { participant: '_participant' };
var _getProgramSummariesRequest = {};
var _getProgramSummariesResponse = {};
var _getResolvedStepRequest = {};
var _getResolvedStepResponse = { resolvedStep: '_resolvedStep' };
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _issueCertificateRequest = {};
var _issueCertificateResponse = { participant: '_participant' };
var _joinProgramRequest = {};
var _joinProgramResponse = { participant: '_participant' };
var _leaveProgramRequest = {};
var _leaveProgramResponse = {};
var _listResolvedStepsRequest = {};
var _listResolvedStepsResponse = { resolvedSteps: '_resolvedStep' };
var _participant = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    progress: '_progress',
    certificate: '_certificate',
};
var _program = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    description: '_description',
    rewards: '_reward',
};
var _programSummary = { program: '_program' };
var _progress = { completionPercentage: 'DOUBLE' };
var _queryParticipantsRequest = {};
var _queryParticipantsResponse = { participants: '_participant' };
var _queryProgramSummariesRequest = {};
var _queryProgramSummariesResponse = { summaries: '_programSummary' };
var _queryResolvedStepsRequest = {};
var _queryResolvedStepsResponse = { resolvedSteps: '_resolvedStep' };
var _resolvedStep = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _resolveStepRequest = {};
var _resolveStepResponse = { resolvedStep: '_resolvedStep' };
var _revertCouponRequest = {};
var _revertCouponResponse = { total: 'DOUBLE' };
var _reward = { certificate: '_rewardCertificate' };
var _rewardCertificate = { connectedDate: 'google.protobuf.Timestamp' };
var _undoStepRequest = {};
var _undoStepResponse = {};
var _videoResolution = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    poster: '_image',
};
var _videoV2 = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    resolutions: '_videoResolution',
    posters: '_image',
};
function resolveWixOnlineprogramsParticipantsV3CouponsServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/participants-service',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixOnlineprogramsParticipantsV3ManageParticipantsServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/participants-service',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixOnlineprogramsParticipantsV3ParticipantsServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/participants-service',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixOnlineprogramsParticipantsV3ResolvedStepsServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/participants-service',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixOnlineprogramsParticipantsV3ParticipantExportsServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/participants-service',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/participants-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Exports data about participants as well as resolved steps in program. */
export function exportParticipantsStats(payload) {
    var _a = serializer(_exportParticipantsStatsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_exportParticipantsStatsResponse, {}).fromJSON;
    function __exportParticipantsStats(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'GET',
            methodFqn: 'wix.onlineprograms.participants.v3.ParticipantExportsService.ExportParticipantsStats',
            url: resolveWixOnlineprogramsParticipantsV3ParticipantExportsServiceUrl({
                protoPath: '/v3/participants/{programId}/export',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __exportParticipantsStats.fromReq = fromReq;
    __exportParticipantsStats.__isAmbassador = true;
    return __exportParticipantsStats;
}
export function resolveStep(payload) {
    var _a = serializer(_resolveStepRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_resolveStepResponse, {
        _resolvedStep: _resolvedStep,
    }).fromJSON;
    function __resolveStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ResolvedStepsService.ResolveStep',
            url: resolveWixOnlineprogramsParticipantsV3ResolvedStepsServiceUrl({
                protoPath: '/v3/participants/{participantId}/steps/{stepId}/resolve',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __resolveStep.fromReq = fromReq;
    __resolveStep.__isAmbassador = true;
    return __resolveStep;
}
export function undoStep(payload) {
    var _a = serializer(_undoStepRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_undoStepResponse, {}).fromJSON;
    function __undoStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ResolvedStepsService.UndoStep',
            url: resolveWixOnlineprogramsParticipantsV3ResolvedStepsServiceUrl({
                protoPath: '/v3/participants/{participantId}/steps/{stepId}/undo',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __undoStep.fromReq = fromReq;
    __undoStep.__isAmbassador = true;
    return __undoStep;
}
export function listResolvedSteps(payload) {
    var _a = serializer(_listResolvedStepsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listResolvedStepsResponse, {
        _resolvedStep: _resolvedStep,
    }).fromJSON;
    function __listResolvedSteps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'GET',
            methodFqn: 'wix.onlineprograms.participants.v3.ResolvedStepsService.ListResolvedSteps',
            url: resolveWixOnlineprogramsParticipantsV3ResolvedStepsServiceUrl({
                protoPath: '/v3/participants/{participantId}/steps',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listResolvedSteps.fromReq = fromReq;
    __listResolvedSteps.__isAmbassador = true;
    return __listResolvedSteps;
}
export function getResolvedStep(payload) {
    var _a = serializer(_getResolvedStepRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getResolvedStepResponse, {
        _resolvedStep: _resolvedStep,
    }).fromJSON;
    function __getResolvedStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'GET',
            methodFqn: 'wix.onlineprograms.participants.v3.ResolvedStepsService.GetResolvedStep',
            url: resolveWixOnlineprogramsParticipantsV3ResolvedStepsServiceUrl({
                protoPath: '/v3/participants/{participantId}/steps/{stepId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getResolvedStep.fromReq = fromReq;
    __getResolvedStep.__isAmbassador = true;
    return __getResolvedStep;
}
export function queryResolvedSteps(payload) {
    var _a = serializer(_queryResolvedStepsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryResolvedStepsResponse, {
        _resolvedStep: _resolvedStep,
    }).fromJSON;
    function __queryResolvedSteps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ResolvedStepsService.QueryResolvedSteps',
            url: resolveWixOnlineprogramsParticipantsV3ResolvedStepsServiceUrl({
                protoPath: '/v3/participants/steps/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryResolvedSteps.fromReq = fromReq;
    __queryResolvedSteps.__isAmbassador = true;
    return __queryResolvedSteps;
}
/** Create resolved steps in batches, needed for migration of participant steps from v1 */
export function bulkCreateResolvedStepMigration(payload) {
    var _a = serializer(_bulkCreateResolvedStepMigrationRequest, { _resolvedStep: _resolvedStep }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateResolvedStepMigrationResponse, { _bulkResolvedStepResult: _bulkResolvedStepResult, _resolvedStep: _resolvedStep }).fromJSON;
    function __bulkCreateResolvedStepMigration(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ResolvedStepsService.BulkCreateResolvedStepMigration',
            url: resolveWixOnlineprogramsParticipantsV3ResolvedStepsServiceUrl({
                protoPath: '/v3/participants/bulk/steps/create/migration',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateResolvedStepMigration.fromReq = fromReq;
    __bulkCreateResolvedStepMigration.__isAmbassador = true;
    return __bulkCreateResolvedStepMigration;
}
/**
 * Member joins the program. By the type of program, participant in corresponding
 * state will be created.
 */
export function joinProgram(payload) {
    var _a = serializer(_joinProgramRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_joinProgramResponse, {
        _certificate: _certificate,
        _participant: _participant,
        _progress: _progress,
    }).fromJSON;
    function __joinProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ParticipantsService.JoinProgram',
            url: resolveWixOnlineprogramsParticipantsV3ParticipantsServiceUrl({
                protoPath: '/v3/participants/{programId}/join',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __joinProgram.fromReq = fromReq;
    __joinProgram.__isAmbassador = true;
    return __joinProgram;
}
/** Returns participant. */
export function getParticipant(payload) {
    var _a = serializer(_getParticipantRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getParticipantResponse, {
        _certificate: _certificate,
        _participant: _participant,
        _progress: _progress,
    }).fromJSON;
    function __getParticipant(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'GET',
            methodFqn: 'wix.onlineprograms.participants.v3.ParticipantsService.GetParticipant',
            url: resolveWixOnlineprogramsParticipantsV3ParticipantsServiceUrl({
                protoPath: '/v3/participants/{participantId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getParticipant.fromReq = fromReq;
    __getParticipant.__isAmbassador = true;
    return __getParticipant;
}
/** Participant leaves program. Entity will be deleted. Idempotent call. */
export function leaveProgram(payload) {
    var _a = serializer(_leaveProgramRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_leaveProgramResponse, {}).fromJSON;
    function __leaveProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ParticipantsService.LeaveProgram',
            url: resolveWixOnlineprogramsParticipantsV3ParticipantsServiceUrl({
                protoPath: '/v3/participants/{participantId}/leave',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __leaveProgram.fromReq = fromReq;
    __leaveProgram.__isAmbassador = true;
    return __leaveProgram;
}
/** Query existing participants */
export function queryParticipants(payload) {
    var _a = serializer(_queryParticipantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryParticipantsResponse, {
        _certificate: _certificate,
        _participant: _participant,
        _progress: _progress,
    }).fromJSON;
    function __queryParticipants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ParticipantsService.QueryParticipants',
            url: resolveWixOnlineprogramsParticipantsV3ParticipantsServiceUrl({
                protoPath: '/v3/participants/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryParticipants.fromReq = fromReq;
    __queryParticipants.__isAmbassador = true;
    return __queryParticipants;
}
export function queryProgramSummaries(payload) {
    var _a = serializer(_queryProgramSummariesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryProgramSummariesResponse, {
        _description: _description,
        _image: _image,
        _program: _program,
        _programSummary: _programSummary,
        _reward: _reward,
        _rewardCertificate: _rewardCertificate,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __queryProgramSummaries(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ParticipantsService.QueryProgramSummaries',
            url: resolveWixOnlineprogramsParticipantsV3ParticipantsServiceUrl({
                protoPath: '/v3/participants/summaries',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryProgramSummaries.fromReq = fromReq;
    __queryProgramSummaries.__isAmbassador = true;
    return __queryProgramSummaries;
}
/** Get summary about participants interacting with the program */
export function getProgramSummaries(payload) {
    var _a = serializer(_getProgramSummariesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getProgramSummariesResponse, {}).fromJSON;
    function __getProgramSummaries(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ParticipantsService.GetProgramSummaries',
            url: resolveWixOnlineprogramsParticipantsV3ParticipantsServiceUrl({
                protoPath: '/v3/participants/summary',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getProgramSummaries.fromReq = fromReq;
    __getProgramSummaries.__isAmbassador = true;
    return __getProgramSummaries;
}
/**
 * Bulk invites participants to program.
 * For each member participant in Invited state is created.
 */
export function bulkInviteToProgram(payload) {
    var _a = serializer(_bulkInviteToProgramRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkInviteToProgramResponse, {
        _bulkInviteToProgramResult: _bulkInviteToProgramResult,
        _certificate: _certificate,
        _participant: _participant,
        _progress: _progress,
    }).fromJSON;
    function __bulkInviteToProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ManageParticipantsService.BulkInviteToProgram',
            url: resolveWixOnlineprogramsParticipantsV3ManageParticipantsServiceUrl({
                protoPath: '/v3/bulk/participants/invite',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkInviteToProgram.fromReq = fromReq;
    __bulkInviteToProgram.__isAmbassador = true;
    return __bulkInviteToProgram;
}
/**
 * Bulk invites all participants to program, but not more then 1000.
 * For each member participant in Invited state is created.
 */
export function bulkInviteAllToProgram(payload) {
    var _a = serializer(_bulkInviteAllToProgramRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkInviteAllToProgramResponse, {}).fromJSON;
    function __bulkInviteAllToProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ManageParticipantsService.BulkInviteAllToProgram',
            url: resolveWixOnlineprogramsParticipantsV3ManageParticipantsServiceUrl({
                protoPath: '/v3/bulk/participants/invite-all',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkInviteAllToProgram.fromReq = fromReq;
    __bulkInviteAllToProgram.__isAmbassador = true;
    return __bulkInviteAllToProgram;
}
/**
 * Bulk adds participants to program.
 * Participant will be either created in state Joined, or updated to that state
 * from pending one.
 */
export function bulkAddToProgram(payload) {
    var _a = serializer(_bulkAddToProgramRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkAddToProgramResponse, {
        _bulkAddToProgramResult: _bulkAddToProgramResult,
        _certificate: _certificate,
        _participant: _participant,
        _progress: _progress,
    }).fromJSON;
    function __bulkAddToProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ManageParticipantsService.BulkAddToProgram',
            url: resolveWixOnlineprogramsParticipantsV3ManageParticipantsServiceUrl({
                protoPath: '/v3/bulk/participants/add',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkAddToProgram.fromReq = fromReq;
    __bulkAddToProgram.__isAmbassador = true;
    return __bulkAddToProgram;
}
/**
 * Bulk adds all site members to program, but not more then 1000.
 * Participant will be either created in state Joined, or updated to that state
 * from pending one.
 */
export function bulkAddAllToProgram(payload) {
    var _a = serializer(_bulkAddAllToProgramRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkAddAllToProgramResponse, {}).fromJSON;
    function __bulkAddAllToProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ManageParticipantsService.BulkAddAllToProgram',
            url: resolveWixOnlineprogramsParticipantsV3ManageParticipantsServiceUrl({
                protoPath: '/v3/bulk/participants/add-all',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkAddAllToProgram.fromReq = fromReq;
    __bulkAddAllToProgram.__isAmbassador = true;
    return __bulkAddAllToProgram;
}
/**
 * Bulk approves participants, who asked to join private program (aka in
 * state `APPROVAL_PENDING`). If participant was in other state, no effect and
 * error returned.
 */
export function bulkApproveParticipant(payload) {
    var _a = serializer(_bulkApproveParticipantRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkApproveParticipantResponse, {
        _bulkApproveParticipantResult: _bulkApproveParticipantResult,
        _certificate: _certificate,
        _participant: _participant,
        _progress: _progress,
    }).fromJSON;
    function __bulkApproveParticipant(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ManageParticipantsService.BulkApproveParticipant',
            url: resolveWixOnlineprogramsParticipantsV3ManageParticipantsServiceUrl({
                protoPath: '/v3/bulk/participants/approve',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkApproveParticipant.fromReq = fromReq;
    __bulkApproveParticipant.__isAmbassador = true;
    return __bulkApproveParticipant;
}
/**
 * Bulk approves all pending participants, who asked to join private program (aka
 * in state `APPROVAL_PENDING`).
 */
export function bulkApproveAllParticipant(payload) {
    var _a = serializer(_bulkApproveAllParticipantRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkApproveAllParticipantResponse, {}).fromJSON;
    function __bulkApproveAllParticipant(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ManageParticipantsService.BulkApproveAllParticipant',
            url: resolveWixOnlineprogramsParticipantsV3ManageParticipantsServiceUrl({
                protoPath: '/v3/bulk/participants/approve-all',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkApproveAllParticipant.fromReq = fromReq;
    __bulkApproveAllParticipant.__isAmbassador = true;
    return __bulkApproveAllParticipant;
}
/**
 * Delete participant from program by owner will. Removes participant from member
 * group. Leaves him in Social Group.
 */
export function deleteParticipant(payload) {
    var _a = serializer(_deleteParticipantRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteParticipantResponse, {}).fromJSON;
    function __deleteParticipant(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'DELETE',
            methodFqn: 'wix.onlineprograms.participants.v3.ManageParticipantsService.DeleteParticipant',
            url: resolveWixOnlineprogramsParticipantsV3ManageParticipantsServiceUrl({
                protoPath: '/v3/participants/{participantId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteParticipant.fromReq = fromReq;
    __deleteParticipant.__isAmbassador = true;
    return __deleteParticipant;
}
/** Issue certificate by site admin */
export function issueCertificate(payload) {
    var _a = serializer(_issueCertificateRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_issueCertificateResponse, {
        _certificate: _certificate,
        _participant: _participant,
        _progress: _progress,
    }).fromJSON;
    function __issueCertificate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.ManageParticipantsService.IssueCertificate',
            url: resolveWixOnlineprogramsParticipantsV3ManageParticipantsServiceUrl({
                protoPath: '/v3/participants/{participantId}/issue-certificate',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __issueCertificate.fromReq = fromReq;
    __issueCertificate.__isAmbassador = true;
    return __issueCertificate;
}
export function applyCoupon(payload) {
    var _a = serializer(_applyCouponRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_applyCouponResponse, {}).fromJSON;
    function __applyCoupon(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.CouponsService.ApplyCoupon',
            url: resolveWixOnlineprogramsParticipantsV3CouponsServiceUrl({
                protoPath: '/v3/participants/{participantId}/coupon/{couponCode}/apply',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __applyCoupon.fromReq = fromReq;
    __applyCoupon.__isAmbassador = true;
    return __applyCoupon;
}
export function revertCoupon(payload) {
    var _a = serializer(_revertCouponRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_revertCouponResponse, {}).fromJSON;
    function __revertCoupon(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.participant',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.participants.v3.CouponsService.RevertCoupon',
            url: resolveWixOnlineprogramsParticipantsV3CouponsServiceUrl({
                protoPath: '/v3/participants/{participantId}/coupon/{couponId}/revert',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __revertCoupon.fromReq = fromReq;
    __revertCoupon.__isAmbassador = true;
    return __revertCoupon;
}
//# sourceMappingURL=http.impl.js.map